import { defineMessages } from 'react-intl';

export default defineMessages({
  bookingConverted: {
    id: 'FulfilmentConverterForm.bookingConverted',
    defaultMessage: 'Booking has been converted – please <a>refresh page</a> to update booking',
  },
});
